import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaEnvelope, FaMapMarkerAlt, FaGraduationCap, FaBriefcase, FaHeart, FaCheck } from 'react-icons/fa';
import './index.scss';

const AboutPage: React.FC = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText('1466717763@qq.com');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      window.location.href = 'mailto:1466717763@qq.com';
    }
  };

  return (
    <section className="about-page">
      <div className="container">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="about-header"
        >
          <div className="avatar">
            <img src="https://avatars.githubusercontent.com/u/33980875?s=400&u=1ca61c5561361f3b5adbf6489701a2e19d06924f&v=4" alt="Avatar" />
          </div>
          <h1>关于我</h1>
          <p className="intro">
            你好！我是一名充满热情的全栈开发工程师，热爱技术，喜欢探索新技术。
          </p>  
        </motion.div>

        <div className="about-content">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="about-section"
          >
            <div className="section-icon">
              <FaBriefcase />
            </div>
            <h2>工作经历</h2>
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <h3>中级全栈开发工程师</h3>
                  <span className="timeline-date">2025- 至今</span>
                  <p>负责公司核心产品的技术开发和支持，主要负责前端和后端的开发，
                    前端涉及React、Node.js等技术栈，
                    后端涉及TDSql、GaussDB数据库+Spring Boot等框架。
                  </p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <h3>初级全栈开发工程师</h3>
                  <span className="timeline-date">2022 - 2024</span>
                  <p>参与多个大型项目的开发，负责前后端开发工作</p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <h3>初级后端开发工程师</h3>
                  <span className="timeline-date">2021 - 2022</span>
                  <p>负责公司核心产品的后端开发工作，主要负责数据库设计、API开发和服务器端逻辑实现，使用MySql、Oracle数据库+Spring Boot等框架，涉及Redis、RabbitMQ、Elasticsearch等中间件，
                    实现系统的高可用性和可扩展性。
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="about-section"
          >
            <div className="section-icon">
              <FaGraduationCap />
            </div>
            <h2>教育背景</h2>
            <div className="education-list">
              <div className="education-item">
                <h3>软件工程 学士</h3>
                <span className="education-date">2017 - 2021</span>
                <p>山东理工大学</p>
              </div>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            className="about-section"
          >
            <div className="section-icon">
              <FaHeart />
            </div>
            <h2>技能特长</h2>
            <div className="skills-grid">
              <div className="skill-category">
                <h3>前端技术</h3>
                <div className="skill-tags">
                  <span className="skill-tag">React</span>
                  <span className="skill-tag">Vue</span>
                  <span className="skill-tag">TypeScript</span>
                  <span className="skill-tag">JavaScript</span>
                  <span className="skill-tag">HTML/CSS</span>
                </div>
              </div>
              <div className="skill-category">
                <h3>后端技术</h3>
                <div className="skill-tags">
                  <span className="skill-tag">Java</span>
                  <span className="skill-tag">Spring Boot</span>
                  <span className="skill-tag">Python</span>
                </div>
              </div>
              <div className="skill-category">
                <h3>数据库</h3>
                <div className="skill-tags">
                  <span className="skill-tag">MySQL</span>
                  <span className="skill-tag">Oracle</span>
                  <span className="skill-tag">GaussDB</span>
                  <span className="skill-tag">TDSql</span>
                  <span className="skill-tag">Redis</span>
                  <span className="skill-tag">Elasticsearch</span>
                </div>
              </div>
              <div className="skill-category">
                <h3>其他技能</h3>
                <div className="skill-tags">
                  <span className="skill-tag">Git</span>
                  <span className="skill-tag">Docker</span>
                  <span className="skill-tag">Linux</span>
                  <span className="skill-tag">DWS(数仓)</span>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            className="about-section contact-section"
          >
            <h2>联系方式</h2>
            <div className="contact-list">
              <a href="https://github.com/LiangZhihui1998" target="_blank" rel="noopener noreferrer" className="contact-item">
                <FaGithub />
                <span>GitHub</span>
              </a>
              <button onClick={handleCopyEmail} className="contact-item copy-button">
                {copied ? <FaCheck /> : <FaEnvelope />}
                <span>{copied ? '已复制!' : '1466717763@qq.com'}</span>
              </button>
              <div className="contact-item">
                <FaMapMarkerAlt />
                <span>浙江·杭州</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutPage;